module.exports = __webpack_public_path__ + "img/yellow-lily.23024a9d.jpg";